import { render } from "./FloatingWhatsApp.vue?vue&type=template&id=504a94a2&scoped=true"
import script from "./FloatingWhatsApp.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsApp.vue?vue&type=script&lang=js"

import "./FloatingWhatsApp.vue?vue&type=style&index=0&id=504a94a2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\sciam\\Desktop\\Workspaces\\local\\workspace_vue\\alternativa-takeaway-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-504a94a2"]])

export default __exports__